// Score-range presets surfaced as a single dropdown on the queue filter bar.
// Four buckets:
//   all  → 1–10 (no filter — opt out of score gating entirely)
//   low  → 1–3  (routes to AutoApprove)
//   mid  → 4–7  (routes to HumanReview, the bulk of the work-pile)
//   high → 8–10 (routes to HumanReview today, AutoBlock once calibrated)
//
// Filtering by score range is conceptually independent of the band filter
// (band is the routing label stored on the event at classification time;
// the dropdown thresholds may shift). We keep them as separate axes.

export type ScoreBand = 'all' | 'low' | 'mid' | 'high';

export interface ScoreBandRange {
  band: ScoreBand;
  min: number;
  max: number;
}

export const SCORE_BANDS: readonly ScoreBandRange[] = [
  { band: 'all', min: 1, max: 10 },
  { band: 'low', min: 1, max: 3 },
  { band: 'mid', min: 4, max: 7 },
  { band: 'high', min: 8, max: 10 },
];

const BAND_BY_KEY: Record<ScoreBand, ScoreBandRange> = {
  all: SCORE_BANDS[0],
  low: SCORE_BANDS[1],
  mid: SCORE_BANDS[2],
  high: SCORE_BANDS[3],
};

export function scoreBandFromRange(min: number, max: number): ScoreBand {
  const exact = SCORE_BANDS.find((b) => b.min === min && b.max === max);
  if (exact) return exact.band;
  // Fall back to the band whose range covers most of the requested range.
  // This handles legacy/URL-mismatched values without crashing.
  if (max <= 3) return 'low';
  if (min >= 8) return 'high';
  return 'mid';
}

export function rangeForScoreBand(band: ScoreBand): { min: number; max: number } {
  const range = BAND_BY_KEY[band];
  return { min: range.min, max: range.max };
}
